module.exports = __webpack_public_path__ + "static/media/Inner Pages - Desktop 970x90.75ed1f4a.png";